export default {
  a: {
    display: 'inline-block',
    fontWeight: 'bold',
    textAlign: 'center',
    textDecoration: 'none',
    WebkitTextSizeAdjust: 'none',
    paddingLeft: '30px',
    paddingRight: '30px',
    maxWidth: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
}
